export const ROLE_URLS = {
  GET_ALL_ROLE: '/role',
  GET_ALL_MODULE: '/role/modules',
  GET_ALL_PERMISSION: '/role/permissions',
  CREATE_ROLE: '/role',
  UPDATE_ROLE: '/role',
  GET_SINGLE_ROLE: '/role/:id',
  DELETE_ROLE: '/role/:id'
};
